const Newsletter = () => {
  const newsletterOpenBtn = document.getElementById('js-newsletter-nav-open')
  const newsletterCloseBtn = document.querySelectorAll(
    '.js-newsletter-close-btn',
  )
  const newsletterModal = document.getElementById('js-newsletter')
  const html = document.getElementsByTagName('html')[0]

  newsletterOpenBtn.addEventListener('click', (e) => {
    newsletterModal.classList.remove('hidden')
    html.classList.add('js--noscroll')
  })

  newsletterCloseBtn.forEach((elm) => {
    elm.addEventListener('click', (e) => {
      newsletterModal.classList.add('hidden')
      html.classList.remove('js--noscroll')
    })
  })
}

export default Newsletter
